import { getBasicInfo } from "../api/generated/wrappers/backdata";
import { createQueryKeys } from "./create-query-keys";
const basicInfoQueryKeys = createQueryKeys("basicInfo", {
    all: () => ({
        queryKey: ["all"],
        queryFn: async () => await getBasicInfo(),
    }),
    classifications: () => ({
        queryKey: ["classifications"],
        queryFn: async () => await getBasicInfo(),
    }),
    manufacturers: () => ({
        queryKey: ["manufacturers"],
        queryFn: async () => await getBasicInfo(),
    }),
    spots: () => ({
        queryKey: ["spots"],
        queryFn: async () => await getBasicInfo(),
    }),
});
export default basicInfoQueryKeys;
